import React from 'react';
import { MenuItem } from '@material-ui/core';
import Field from '../../../../../components/forms/fields/Field';
import { TextField } from '../../../../../ui-kit';
import { CategorySelectProps,  } from './types';
import ParentOption from './ParentOption';
import ChildOption from './ChildOption';

const CategorySelect = <T, >({ options, placeholder, showEmpty, ...other }: CategorySelectProps<T>) => (
    <Field
        renderer={TextField}
        renderValue={(value: string) => {
            const selectedOption = options.find(({ id }) => value === id);
            return selectedOption ? selectedOption.name : '';
        }}
        select
        {...other}
    >
        {placeholder && (<MenuItem value="" disabled>{placeholder}</MenuItem>)}
        {showEmpty && (<MenuItem value='null'>&mdash;</MenuItem>)}
        {options.map(({ id, name, color, parent }) => (
            <MenuItem key={id} value={id}>
                {parent
                    ? <ParentOption name={name} color={color} />
                    : <ChildOption name={name} color={color} />}
            </MenuItem>
    ))}
    </Field>
);

export default CategorySelect;